import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ModalConfirmComponent } from './modal-confirm.component';


@Injectable()
export class ModalConfirmService {

  constructor(public dialog: MatDialog) { }

	openAlertModal(title?: string, topText?: string, text?: string, confirmButton?: string , hideBackButton?: boolean){
		this.dialog.open(ModalConfirmComponent, {
			width: '420px',
			data: {
				title: title,
				topText: topText,
				text: text,
				confirmButton: confirmButton,
				hideBackButton: hideBackButton
			}
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-confirm/modal-confirm.service.ts